import { render } from "./AssStudentMaster.vue?vue&type=template&id=7bba299e&scoped=true"
import script from "./AssStudentMaster.vue?vue&type=script&lang=js"
export * from "./AssStudentMaster.vue?vue&type=script&lang=js"

import "./AssStudentMaster.vue?vue&type=style&index=0&id=7bba299e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bba299e"]])

export default __exports__